import React from "react";
import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";
import { ButtonWithLoadingIndicator, CancelButton } from '../components-atoms';
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";
export const CancelCollectOrderModal = (props: any) => {
  const classes = useStyles();
  const { data } = props;

  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}></Grid>
        <Grid item className={classes.titleSection}>
          <Typography variant="h6" component="h6" color="textPrimary">
            Cancel order
          </Typography>
        </Grid>
        <Grid item className={classes.bodySection}>
          <Grid item container direction="row">
            <Typography variant="body2" component="p" color="textPrimary">
              {"You are about to cancel the order "}
            </Typography>
            <Typography
              variant="body2"
              component="p"
              data-automation="order-number"
              color="textPrimary"
              style={{ fontWeight: "bold", marginLeft: 3 }}
            >
              {data.ReferenceNumber}
            </Typography>
          </Grid>
          <Typography
            variant="body2"
            component="p"
            className={classes.mt8}
            color="textPrimary"
          >
            Are you sure you want to cancel this order?
          </Typography>
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end">
          <CancelButton onClick={props.onClose} />
          <ButtonWithLoadingIndicator
            disabled={props.loading}
            loading={props.loading}
            onClick={props.onRejectButtonPressed}
            className={classes.rejectButton}
            title="Yes, cancel order"
          />
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    backgroundColor: "white",
    maxWidth: "480px",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },

  titleSection: {
    marginBottom: "8px",
  },
  bodySection: {
    marginBottom: "52px",
  },
  rejectButton: {
    borderRadius: "8px",
    padding: "6px 16px",
    ...buttonHoverAndActive
  },
  mt8: {
    marginTop: 8,
  },
});
